'use strict';

const { checkMandatoryFields } = require('../subHelpers/adformConfigValidatorSubHelper');

/**
 * Checks if config has good structure and mandatory properties (tagId...) for non slider type (mega menu ad...).
 *
 * @param {Object} containerTypeConfig - config in adformConstants.js holding tagid, img sizes and similar (e.g. CONTAINER_TYPE_CATEGORY_CONFIG)
 * @return {boolean} - if config is valid
 */
function isContainerTypeConfigValidForNonSlider(containerTypeConfig) {
    return checkMandatoryFields(containerTypeConfig)
        && containerTypeConfig.isInSlider === false
        && [true, false].includes(containerTypeConfig.isMegaMenuAd);
}

module.exports = {
    checkMandatoryFields: checkMandatoryFields,
    isContainerTypeConfigValidForNonSlider: isContainerTypeConfigValidForNonSlider
};
